import { Component, ElementRef, Input, OnInit, ViewChild } from '@angular/core';
import { StateService } from '@uirouter/angular';
import { NgbModal, ModalDismissReasons, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { ApiService } from '../../services/api.service';
import { FrontEndService } from '../../services/front-end.service';
import { DataService } from "../../services/data.service";
import { Message } from '@angular/compiler/src/i18n/i18n_ast';
import { LogService } from '../../services/log.service';

@Component({
  selector: 'app-forgot-popup',
  templateUrl: './forgot-popup.component.html',
  styleUrls: ['./forgot-popup.component.scss']
})
export class ForgotPopupComponent implements OnInit {

  modalRef: NgbModalRef;
  closeResult: any;
  changePassword = {};
  forgotAlertMsg = "";
  isAvailable = false;
  loading = false;

  constructor(
    private modalService: NgbModal,
    private apiService: ApiService,
    private stateService: StateService,
    private frontEndService: FrontEndService,
    private dataService: DataService,
    private logService: LogService
  ) { }

  ngOnInit() {
    
  }
  @ViewChild("forgotModalContent") private forgotModalContent: ElementRef;

  closeModal() {
    // this.logService.printLog("Closing modal");
    this.modalRef.close();
  }
  open() {
    this.modalRef = this.modalService.open(this.forgotModalContent);
    // this.logService.printLog("Right modal opened");
    this.modalRef.result.then((result) => {
      this.closeResult = `Closed with: ${result}`;
    }, (reason) => {
      this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
    });
  }

  private getDismissReason(reason: any): string {
    if (reason === ModalDismissReasons.ESC) {
      return 'by pressing ESC';
    } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
      return 'by clicking on a backdrop';
    } else {
      return `with: ${reason}`;
    }
  }

  passwordChange() {
    this.loading = true;
    this.apiService.forgotPassword(this.changePassword, (response) => {
      this.loading = false;
      this.logService.printLog ("For change password -", response);
      // this.closeModal();
      if (response.status == true) {
        this.forgotAlertMsg = response.message;
        this.loading = false;
        this.frontEndService.addToast('Success', response['message'], 'info');
        this.closeModal();
        this.changePassword["username"] = '';
        this.isAvailable  = false;
        
      }else {
        this.forgotAlertMsg = response.message;
        this.loading = false;
        // document.querySelector('#fmsg').classList.remove('text-success');
        // document.querySelector('#fmsg').classList.add('text-danger');
        this.isAvailable = true;
      }
    });
  }

}



// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/landing_page/src/app/components/forgot-popup/forgot-popup.component.ts